import { Box, styled } from "@mui/material";

export const CellWrapper = styled(Box)`
  display: flex;
  height: 100%;
  width: 100%;
  justify-content: center;
  align-items: center;
`;
